import { CouponListItemViewModel, InvoiceComplexDetailViewModel, InvoiceListItemViewModel } from "@payping/api";
import { CLEAR_LIST, LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";
import { CouponState } from "./coupons";

export const INVOICES_LOADED = "INVOICES_LOADED";
export const SET_INVOICE_DETAILS = "SET_INVOICE_DETAILS";
export const INVOICE_REMOVED = "INVOICE_REMOVED";
export const INVOICE_COUPONS_LOADED = "INVOICE_COUPONS_LOADED";

export interface InvoiceState {
  list: InvoiceListItemViewModel[];
  totalCount: number;
  paginationEnd: boolean;
  details?: InvoiceComplexDetailViewModel;
  coupon?: CouponState;
}

export interface InvoicesLoadedAction {
  type: typeof INVOICES_LOADED;
  payload: { list: InvoiceListItemViewModel[]; totalCount: number; append: boolean };
}

export interface SetInvoiceDetailsAction {
  type: typeof SET_INVOICE_DETAILS;
  payload: { details: InvoiceComplexDetailViewModel };
}

export interface InvoiceRemovedAction {
  type: typeof INVOICE_REMOVED;
  payload: { code: string };
}

export interface InvoiceCouponsLoadedAction {
  type: typeof INVOICE_COUPONS_LOADED;
  payload: { list: CouponListItemViewModel[]; totalCount: number; append: boolean };
}

export type InvoiceActionTypes =
  | InvoicesLoadedAction
  | SetInvoiceDetailsAction
  | InvoiceRemovedAction
  | ClearListAction
  | InvoiceCouponsLoadedAction
  | LoggedOutAction;

const initialState: InvoiceState = {
  coupon: {
    details: undefined,
    list: [],
    paginationEnd: false,
    totalCount: 0,
  },
  details: undefined,
  list: [],
  paginationEnd: false,
  totalCount: 0,
};

export default function invoices(state = initialState, action: InvoiceActionTypes): InvoiceState {
  if (action.type === INVOICES_LOADED) {
    const { list, totalCount, append } = action.payload;
    const newList = append ? [...state.list, ...list] : list;
    return {
      ...state,
      list: newList,
      paginationEnd: !list.length || newList.length >= totalCount,
      totalCount,
    };
  }

  if (action.type === SET_INVOICE_DETAILS) {
    const { details } = action.payload;
    return {
      ...state,
      details,
    };
  }

  if (action.type === INVOICE_COUPONS_LOADED) {
    const { list, totalCount, append } = action.payload;
    const newList = append && state.coupon?.list ? [...state.coupon.list, ...list] : list;
    return {
      ...state,
      coupon: {
        list: newList,
        paginationEnd: !list.length || newList.length >= totalCount,
        totalCount,
      },
    };
  }

  if (action.type === CLEAR_LIST) {
    return {
      ...state,
      list: [],
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
